// Placeholder cards shown while the search index boots. They match the real
// card's geometry exactly, so nothing shifts when results replace them.

export function LibrarySkeletonCard() {
  return (
    <div
      aria-hidden
      className="overflow-hidden rounded-2xl bg-card ring-1 ring-border/50"
    >
      <div className="gem-shimmer aspect-[2/1] w-full" />
      <div className="flex flex-col gap-3 p-5">
        <div className="gem-shimmer h-3 w-20 rounded-full" />
        <div className="gem-shimmer h-5 w-2/3 rounded-md" />
        <div className="gem-shimmer h-3 w-full rounded-full" />
        <div className="gem-shimmer h-3 w-4/5 rounded-full" />
        <div className="mt-2 flex items-center justify-between border-t border-border/40 pt-3">
          <div className="gem-shimmer h-3 w-24 rounded-full" />
          <div className="gem-shimmer h-4 w-12 rounded-full" />
        </div>
      </div>
    </div>
  );
}

export function LibrarySkeletonGrid({ count = 12 }: { count?: number }) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <LibrarySkeletonCard key={i} />
      ))}
    </>
  );
}
